import React, { useEffect, useState } from 'react'
import { Box, Button, Link, Text } from '@rebeldotcom/components'
import { isInternic } from '@rebeldotcom/ui'
import {
  getConsentCookie,
  getConsentGroup,
  setConsentCookie,
} from '../utilities/consent-cookie'

const choose = (agreed, setBannerOpen) => {
  setConsentCookie(agreed ? 'agreed' : 'declined')
  // cookie write can be blocked by browser privacy settings; don't close if it didn't land
  if (!getConsentCookie()) return
  setBannerOpen(false)
  if (agreed) {
    // reload re-checks the ga-disable-<id> cookie cleared above to re-enable GA
    window.location.reload()
  }
}

const ConsentBanner = () => {
  // starts closed so build-time markup matches client hydration (no cookies at build time)
  const [bannerOpen, setBannerOpen] = useState(false)

  useEffect(() => {
    setBannerOpen(
      isInternic && getConsentGroup() === 'regulated' && !getConsentCookie()
    )
  }, [])

  if (!bannerOpen) return null

  return (
    <Box
      aria-label="Cookie consent"
      aria-live="polite"
      bg="rgba(255, 255, 255, 0.8)"
      bottom={0}
      css={{
        backdropFilter: 'blur(16px)',
        zIndex: 50,
        padding: '1.6rem',
        // desktop: keep buttons clear of the floating chat launcher (bottom-right, ~6rem wide)
        // mobile: stacked layout, so lift the content above the launcher instead
        '@media (min-width: 600px)': { paddingRight: '9rem' },
        '@media (max-width: 599px)': { paddingBottom: '4rem' },
        gap: '1.6rem',
      }}
      alignItems={[null, 'center']}
      display="flex"
      flexDirection={['column', 'row']}
      justifyContent="space-between"
      position="fixed"
      px={[1.6, 4]}
      py={1.6}
      role="region"
      width="100%"
    >
      <Text variant="small">
        We use cookies and analytics — including linking your activity to your
        account when you&apos;re signed in — to run and improve Internic. See
        our{' '}
        <Text as="span" css={{ textDecoration: 'underline' }}>
          <Link to="/privacy-policy/">Privacy Policy</Link>
        </Text>{' '}
        for details.
      </Text>
      <Box css={{ gap: '1.2rem' }} display="flex" flexShrink={0}>
        <Button onClick={() => choose(false, setBannerOpen)}>
          Do Not Agree
        </Button>
        <Button onClick={() => choose(true, setBannerOpen)}>Agree</Button>
      </Box>
    </Box>
  )
}

export { ConsentBanner }
